<template>
  <div class="down-cont">
    <span class="link view-content-link" @click="viewFile">{{ viewContent }}</span>
    <span class="link download-link" @click="downloadFile">{{ downloadContent }}</span>
  </div>
</template>

<script>
export default {
  name: 'UcPdfUse',
  props: {
    type: {
      type: String,
      default: 'supplier_auth' // 资金方授权书：finance_auth，供应商授权书：supplier_auth
    },
    fileName: {
      type:String,
      default: '授权委托书'
    }, 
    info: Object,
    viewContent: {
      type: String,
      default: '查看示例'
    },
    downloadContent: {
      type: String,
      default: '下载模板'
    },
    isPublic: { // 未登录时接口权限
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      
    }
  },
  methods: {
    async getUrl() {
      let s = new Date()
      s.setMonth(s.getMonth()-1 + 6)
      // debugger
      const params = {
        ftlNo: this.type,
        ubsinessDataMap: {
          // usrName: this.info.usrName,
          // certNo: this.info.certNo,
          sYear: String(new Date().getFullYear()),
          sMonth:String(new Date().getMonth()+1),
          sDay:String(new Date().getDate()),
          eYear:String(s.getFullYear()),
          eMonth:String(s.getMonth()+1),
          eDay:String(s.getDate()),
          nYear:String(new Date().getFullYear()),
          nMonth:String(new Date().getMonth()+1),
          nDay:String(new Date().getDate()),
          ...this.info
        }
      }
      const applyUrl = this.isPublic ? 'bds/publicrs/contract/template' : 'bds/contract/template'
      const res = await this.$POST( applyUrl, params, {'responseType': 'blob'})
      if(res.type == 'application/octet-stream') { // 返回的不是文件流,j提示用户返回的报错信息
        return res
      } else {
        if (res.type == 'application/json') { // 接口报错
          this.fileReader(res)
        } else {
          console.log(res.message)
        }
      }
    },
    fileReader(res) {
      const reader = new FileReader()
      reader.onload = () => {
        const err = JSON.parse(reader.result) // 还原成报错信息
        // this.$message.error({ showClose: true, message: err.msg || err.message})
        return ''
      }
      reader.readAsText(res)
    },
    async downloadFile() {
      const binaryData = await this.getUrl()
      if (binaryData) {
        const url = window.URL.createObjectURL(new Blob([binaryData], { type: 'application/pdf;' }))
        const link = document.createElement('a');
        link.style.display = 'none'
        link.href = url;
        link.download = `${this.fileName}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    },
    async viewFile() {
      const binaryData = await this.getUrl()
      if (binaryData) {
        const url = window.URL.createObjectURL(new Blob([binaryData], { type: 'application/pdf;chartset=UTF-8' }))
        const link = document.createElement('a');
        link.style.display = 'none'
        link.href = url;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.down-cont {
  // margin-top: 4px;
  .link {
    cursor: pointer; 
    color: #1b5bbf;
    font-size: 14px;
    margin-right: 15px;
  }
}
</style>